define.alias("shared/helpers/is-last", "media/helpers/is-last");